import { $,_,Backbone,Marionette,Radio,GoogleMaps } from '../../../vendor'
import { Notification,Biscuit } from '../../utils'
import InboomaBaseView from '../InboomaBaseView'
import Location from '../../models/Location'
import { mapMarker } from '../../App'

import LocationsForm from './LocationsForm'

import LocationsViewTpl from '../../templates/contingents/LocationsViewTpl.html'

const a = '${a}';

const LocationItemView = InboomaBaseView.extend({

    popupTpl : _.template(
      `<div class="locationItemPopup">
        <h4>
          <%- name %>
        </h4>
        <p class="description">
          <%- description %>
        </p>
        <% if (contingents.models.length >= 1) { %>
        <ul class="inb-vert-list">
          <span class="inb-list-title">
            <%= t("contingents",null,"capital") %>
          </span>
          <% _.each(
              _.sortBy(contingents.models, function(model) { return model.get('name') }),
              function(contingent, key) { var number_active = contingent.getNumbersByToday() %>
            <li>
              <a href="/contingents/<%- contingent.id %>">
                <%- contingent.get("name") %> <%- contingent.getFormattedTags() %>
                <% if (number_active) { %>
                  (<%- number_active.number %> <%= t("vehicles_active") %>)
                <% } %>
              </a>
            </li>
          <% }); %>
          <% } else { %>
            <li><%= t("no_contingents_yet") %></li>
          <% } %>
        </ul>
        <% if (user_role === 'admin') { %>
        <hr />
        <a
            href="/locations/<%- id %>/edit"
            class="location__edit">
            <%= t("edit",null,"capital") %>
        </a> 
        | 
        <a
            href="/locations/<%- id %>/remove"
            class="location__remove">
            <%= t("remove",null,"capital") %>
        </a>
        | 
        <% } %>
        <% if (user_role === 'admin' || user_role === 'manager' || user_role === 'manager_location') { %>
        <a
            href="/check_in_periods?location_id=<%- id %>"
            title="<%= t('edit_${a}',{a:t('opening_times')}) %>"
            class="location__opening_times">
            <%= t("opening_times",null,"capital") %>
        </a>
        <% } %>
      </div>`),

    tagName : 'li',

    template : _.template(
        `<span class="inb-location-<%- id %>">
            <%- name %>
         </span>`
    ),

    events : {
        'click span' : '_onClickListItem'
    },

    mapMarker : {
        url : '',
        width : 0,
        height : 0,
        scaleDown : false,
        ready: false
    },

    initialize () {
        this.map = this.options.map;
        this.markers = this.options.markers;
    },

    onRender () {
console.log("RENDER start: ",mapMarker);
        const that = this;

        // Set templateContext via model:
        this.model.set('t', this.t);
        this.model.set('user_role', Biscuit.get('user.role'));

        const clientProduct = Biscuit.get('client.product');

        let markerImage = Biscuit.get('client.marker');

        if (typeof markerImage === 'undefined' || markerImage === '' || markerImage === null) {
            if (typeof clientProduct !== 'undefined' && clientProduct == 'inbooma.net Booking Software') {
                // Default client
                markerImage = 'assets/img/default-map-marker.png';
            } else {
                // Bikesharing client
                markerImage = 'assets/img/default-map-marker-bikesharing.png';
            }
        }
        
        // This should only be a temporary solution
        // Actual "problem": On initial page load, LocationsView becomes called too early so client
        // logo & marker is not set yet. Solution: Defer rendering, e.g. via dedicated Radio-event called from App.js
        // or (too be developed) via InboomaBaseView (e.g. this.dependencies = { models: { type: 'client', id: Biscuit.get('user.client_id') } })
        if (Number(Biscuit.get('user.client_id')) === 7) {
            markerImage = 'https://s3.eu-central-1.amazonaws.com/inbooma/images/rab_mapmarker.png';
        }

        if (Number(Biscuit.get('user.client_id')) === 11) {
            markerImage = 'assets/img/default-map-marker-bikesharing.png';
        }

        let iconSize = {
            width : mapMarker.width == 0 ? 80 : mapMarker.width,
            height : mapMarker.height == 0 ? 100 : mapMarker.height,
        }
        var markerIcon = {
            url: markerImage, // url
            scaledSize: new google.maps.Size(iconSize.width, iconSize.height), // eventually scale down
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };

        let pos = {
            lat: (Number.isNaN(that.model.get('latitude')) || that.model.get('latitude') == '' || that.model.get('latitude') == ' ') ? 0.0 : that.model.get('latitude'),
            lng: (Number.isNaN(that.model.get('longitude')) || that.model.get('longitude') == '' || that.model.get('longitude') == ' ') ? 0.0 : that.model.get('longitude'),
        }
        console.log("latitude: ",pos);
        this._marker = new google.maps.Marker({
            position: pos,
            map: that.map,
            icon: mapMarker.scaleDown ? markerIcon : markerImage
        }); 

        this.markers.push(this._marker);

        this._marker.addListener('click', () => {

            that.$el.addClass('active');

            const modelReady = this.model.get('created') !== '';
            
            $('.gm-style-iw').parent()
                             .remove();

            const setOpenInfoWindow = () => {
                // Wait till model data is complete, then render
                // and open an InfoWindow
                const infowindow = new google.maps.InfoWindow({
                    content: that.popupTpl(that.model.toJSON())
                });
                
                infowindow.open(that.map, that._marker);
                that.map.setCenter(infowindow.getPosition());
            }


            if (modelReady) {
                setOpenInfoWindow();
            } else {
                that.model.fetch({
                    success (model, response) {
                        that.model.setChildren();
                        setOpenInfoWindow();
                    }
                });
            }

        });

        this._marker.addListener('mouseover', () => {
            $('#locationsList li.active').removeClass('active');
            this.$el.addClass('active');
        });

        this._marker.addListener('mouseout', () => {
            $('#locationsList li.active').removeClass('active');
        });

        if (this.model.get('geofence') && parseInt(this.model.get('geofence')) > 0) {
            // Draw geofence
            new google.maps.Circle({
                  strokeColor: '#FF0000',
                  strokeOpacity: 0.8,
                  strokeWeight: 1.5,
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  map: that.map,
                  center: pos,
                  radius: Math.sqrt(parseInt(that.model.get('geofence'))) * 10          // ????? geofence is already the radius in meter
            });
        }
    },

    _onClickListItem () {
      
        // Open related map popup
        $('#locationsList li.active').removeClass('active');
        this.$el.addClass('active');
        this.map.setCenter(this._marker.getPosition());
        new google.maps.event.trigger(this._marker, 'click');

    }

});

const LocationCollectionView = Marionette.CollectionView.extend({

    el : '#locationsList #locationsList__content',
    childView : LocationItemView,
    _markers : [],

    childViewOptions () {
        return {
            map : this.map,
            widgetMode : this.getOption('widgetMode'),
            markers : this._markers
        }
    },
    
    initialize () {
        // Init map and pass it as reference to childViews

        const that = this,
            appChannel = Radio.channel('app'),
            settings = appChannel.request('get:settings'),
            onRouterExecute = function(from, to) {
                // Free from memory
                if (document.getElementById('map')) {
                    that._mapReference.maps.event.clearInstanceListeners(document.getElementById('map'));
                }
                appChannel.off('router:execute', onRouterExecute); 
        }

        appChannel.on('router:execute', onRouterExecute);

        GoogleMaps.KEY = settings.GOOGLE_MAPS_API_KEY;
        GoogleMaps.VERSION = 'weekly';

        GoogleMaps.load(function(google) {

          that._mapReference = google;

          that.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 12,
            mapTypeControlOptions: { mapTypeIds: [] }
          });

          that.render();

        });

    },

    onRender () {

        let markers = this._markers;

        const markerCount = this.collection.models.length;

        if (markerCount > 1) {

            let bounds = new google.maps.LatLngBounds()

            for (let i = 0; i < markers.length; i++) {
              bounds.extend(markers[i].getPosition())
            }

            // Increase propability that all markers will be seen
            // in dashboard
            this.map.fitBounds(bounds, {top:0,bottom:(this.options.widgetMode ? 180 : 0),left:0,right:0});

        } else if (markerCount === 1) {

            this.map.setZoom(15);
            //markers[0].position == { lat: func(), lng: func() }
            this.map.setCenter(markers[0].position); //- (this.options.widgetMode ? 0.03 : 0));

        } else if (markerCount === 0) {

            // Vatikanstadt haha
            this.map.setZoom(16);
            this.map.setCenter({lat:41.9038243,lng:12.4476838});

        }
    }

});

export default InboomaBaseView.extend({

    template : LocationsViewTpl,
    el : '#inb-c-main-contingents',

    ui : {
        'modal' : '#inb-modal-locations',
        'searchInput' : '#locationsList__search'
    },

    events : {
        'keyup @ui.searchInput' : '_search'
    },

    templateContext () {
        return {
            collectionIsEmpty : (this.collection.models.length === 0)
        }
    },

    _search () {

        const val = this.getUI('searchInput')
                        .val()
                        .toLowerCase();

        if (val.length >= 1) {
            this.collection.filterByQuery(val);
        } else {
            this.collection.removeFilter('query');
        }
    },

    add () {

        const locationsForm = new LocationsForm({
            el : this.getUI('modal'),
            model : new Location(),
            collection : this.collection._superset
        });
    },

    edit (id) {

        const locationsForm = new LocationsForm({
            el : this.getUI('modal'),
            model : this.collection._superset.get(id),
            collection : this.collection._superset,
        });
    },

    remove (id) {

        const that = this;

        if (confirm(this.t('really_remove'))) {
            this.collection
                ._superset
                .get(id)
                .destroy({
                    success () {
                      
                        new Notification({
                          message : that.t('removed_${a}',{a:that.t('location')},'capital'),
                          duration : 9000,
                          type : 'success',
                          closeable : true,
                          icon : 'fi fi-check'
                        });

                        /*
                        Unset orders to force browser to re-fetch
                        @todo test in non-RAB-account
                        if (typeof Radio._channels['orders'] !== 'undefined') {
                          Radio.request('orders');
                          delete Radio._channels['orders'];
                        }
                        */
                        
                        Backbone.history.navigate('locations', { trigger : true });
                    },
                    error (__, response) {
                        if (typeof response.responseJSON !== 'undefined') {
                            if (typeof response.responseJSON.data !== 'undefined') {
                                if (typeof response.responseJSON.data.message !== 'undefined') {
                                    alert(response.responseJSON.data.message);
                                }
                            }
                        }
                    }
            });
        }

  },

  initialize () {

      const remainingLoadMoreBtn = document.querySelector('.inb-next-page-button');
      
      if (remainingLoadMoreBtn) {
          remainingLoadMoreBtn.remove();
      }

      this.widgetMode = (this.getOption('widgetMode'));
      this.collection = Radio.channel('locations').request('get:data').proxy;
      
      this.collection.removeFilter('query');

      const that = this;

      this.collection.on('forceRender', function() {
          that.render();
      });

      this.render();

  },

  onRender () {

      if (this.options.el) {
          this.setElement(this.options.el);
      }

      if (Biscuit.get('user.role') !== 'admin') {
          // @todo not the best place to put
          this.$el.find('#location__add').remove();
      }
      
      const locationCollectionView = new LocationCollectionView({
          collection : this.collection,
          widgetMode : this.widgetMode
      });

  }

});
